module.exports = __webpack_public_path__ + "img/about-m-slide-23.90ec64fc.jpg";